export function _getBookElemDesc($: JQueryStatic)
{
	return $('#details .description')
}
